'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ItemCard-module_itemInfo__DPCj9{display:flex;flex:1;flex-direction:column;gap:4px;padding:0}.ItemCard-module_itemInfoDetail__Zewft{align-items:center;display:flex;gap:8px;margin:0}@media screen and (max-width:768px){.ItemCard-module_itemInfoDetail__Zewft{font-size:12px;line-height:16px}}.ItemCard-module_itemName__W2uvQ{margin:0;padding:0 0 4px}";
var styles = {"itemInfo":"ItemCard-module_itemInfo__DPCj9","itemInfoDetail":"ItemCard-module_itemInfoDetail__Zewft","itemName":"ItemCard-module_itemName__W2uvQ"};
styleInject["default"](css_248z, 'f8e52727-cf4a-49ac-b3a1-032e61735ce1');

exports["default"] = styles;
